<template>
  <div class="architect-users">
    <v-dialog v-model="dialog" max-width="800" persistent>
      <v-card v-if="company">
        <v-card-text>
          <div class="d-flex justify-space-between pt-2">
            <h3 class="black--text">{{ company.name }} Users</h3>
            <v-icon @click="close">mdi-close</v-icon>
          </div>
          <v-divider class="black--text"></v-divider>
          <div class="text-right">
            <v-btn depressed color="primary" @click="inviteModal = true"
              >Invite</v-btn
            >
          </div>
          <v-data-table
            :headers="headers"
            :items="users"
            :search="searchQuery"
            :loading="loading"
            no-data-text="No user found"
          >
            <template v-slot:[`item.name`]="{ item }">
              <div class="d-flex align-center pr-2 py-2">
                <div>
                  <v-avatar tile color="primary" size="52">
                    <span class="display-1 text-capitalize white--text">{{
                      item.name.charAt(0)
                    }}</span>
                  </v-avatar>
                </div>
                <div class="ml-1">
                  <h6 class="primary--text pb-0 mb-0">
                    <strong>{{ item.name }}</strong>
                  </h6>
                  <div>
                    <span>{{ item.email }} </span>
                  </div>
                </div>
              </div>
            </template>
            <template v-slot:[`item.access_role`]="{ item }">
              <v-chip
                v-for="role in item.access_role"
                :key="role"
                small
                class="mr-1"
                color="grey lighten-3"
                >{{ role }}</v-chip
              >
            </template>
            <template v-slot:[`item.is_suspended`]="{ item }">
              <span
                :class="item.is_suspended ? 'red--text' : 'success--text'"
                >{{ item.is_suspended ? "Suspended" : "Active" }}</span
              >
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-menu offset-y left>
                <template v-slot:activator="{ on }">
                  <transition name="slide-fade" mode="out-in">
                    <v-btn icon v-on="on">
                      <v-icon size="32" color="primary">
                        mdi-dots-horizontal
                      </v-icon>
                    </v-btn>
                  </transition>
                </template>
                <v-list dense>
                  <v-list-item @click="editUser(item)">
                    <v-icon size="18" class="mr-1">mdi-cog</v-icon>
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="!item.is_suspended"
                    @click="deactivateUser(item)"
                  >
                    <v-icon size="18" class="mr-1"
                      >mdi-minus-circle-outline</v-icon
                    >
                    <v-list-item-title>Suspend</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="item.is_suspended"
                    @click="reactivateUser(item)"
                  >
                    <v-icon size="18" class="mr-1"
                      >mdi-plus-circle-outline</v-icon
                    >
                    <v-list-item-title>Unsuspend</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="deleteUser(item)">
                    <v-icon size="18" class="mr-1">mdi-delete</v-icon>
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <InviteUser
        v-if="inviteModal"
        :dialog="inviteModal"
        type="architect"
        :id="company.id"
        @close="inviteModal = false"
      />

      <SuspendArchitect
        v-if="deactivateModal && selectedItem"
        :dialog="deactivateModal"
        :architectInfo="selectedItem"
        :company="company"
        @refresh="refresh"
        @close="deactivateModal = false"
      />

      <EditArchitect
        v-if="editModal && selectedItem"
        :dialog="editModal"
        :architectInfo="selectedItem"
        :company="company"
        @refresh="refresh"
        @close="editModal = false"
      />

      <DeleteArchitect
        v-if="deleteModal && selectedItem"
        :dialog="deleteModal"
        :item="selectedItem"
        :company="company"
        @refresh="refresh"
        @close="deleteModal = false"
      />

      <ReactivateArchitect
        v-if="reactivateModal && selectedItem"
        :dialog="reactivateModal"
        :architectInfo="selectedItem"
        :company="company"
        @refresh="refresh"
        @close="reactivateModal = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import states from "@/configs/states.json";
import InviteUser from "@/components/user/InviteUser";
import EditArchitect from "@/components/architect/user/EditArchitect";
import DeleteArchitect from "@/components/architect/user/DeleteArchitect";
import SuspendArchitect from "@/components/architect/user/SuspendArchitect";
import ReactivateArchitect from "@/components/architect/user/ReactivateArchitect";
export default {
  components: {
    InviteUser,
    EditArchitect,
    DeleteArchitect,
    SuspendArchitect,
    ReactivateArchitect
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    company: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      states,
      searchQuery: null,
      loading: false,
      saveLoading: false,
      inviteModa: false,
      deactivateModal: false,
      reactivateModal: false,
      deleteModal: false,
      inviteModal: false,
      editModal: false,
      selectedItem: null,
      users: [
        {
          id: 1,
          name: "Joe Shmoe",
          email: "joe@email.com",
          role: "Admin",
          status: true
        }
      ],
      headers: [
        {
          text: "Users",
          value: "name"
        },
        {
          text: "Status",
          value: "is_suspended"
        },
        {
          text: "Roles",
          value: "access_role"
        },
        {
          text: "Actions",
          value: "actions"
        }
      ]
    };
  },
  created() {
    if (this.company) {
      this.getArchitectsByCompany();
    }
  },
  methods: {
    getArchitectsByCompany() {
      this.users = [];
      this.loading = true;
      this.$store
        .dispatch("architect/getArchitectsByCompany", this.company.id)
        .then(resp => {
          this.users = resp.map(user => {
            return {
              ...user,
              name: user.first_name + " " + user.last_name
            };
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.$emit("close");
    },
    refresh() {
      this.deactivateModal = false;
      this.reactivateModal = false;
      this.editModal = false;
      this.deleteModal = false;

      this.getArchitectsByCompany();
    },
    editUser(user) {
      this.selectedItem = { ...user };
      this.editModal = true;
    },
    deactivateUser(user) {
      this.selectedItem = { ...user };
      this.deactivateModal = true;
    },
    reactivateUser(user) {
      this.selectedItem = { ...user };
      this.reactivateModal = true;
    },
    deleteUser(user) {
      this.selectedItem = { ...user };
      this.deleteModal = true;
    },
    save() {
      if (this.$refs.form.validate()) {
        return;
      }
    }
  }
};
</script>
